// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Dashboard Context Section ─── */
.DashboardContextSection_section__r0nnL {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 28px;
  background: var(--bg-2, #fff);
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
}

.DashboardContextSection_head__dxCr5 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.DashboardContextSection_eyebrow__S3L7K {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--accent-color, #0f3460);
  opacity: 0.75;
}

.DashboardContextSection_title__aknQb {
  margin: 0;
  font-family: "Lora", "Georgia", serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
}

.DashboardContextSection_subtitle__iZrXX {
  margin: 0;
  font-size: 13px;
  color: var(--grey-text, #64748b);
  line-height: 1.5;
}

/* ─── KPI Cards ─── */
.DashboardContextSection_kpis__bV-B8 {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.DashboardContextSection_kpi__d3ftl {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 18px 20px;
  border-radius: 12px;
  background: linear-gradient(140deg, rgba(15, 52, 96, 0.06) 0%, rgba(15, 52, 96, 0.015) 100%);
  border: 1px solid rgba(15, 52, 96, 0.08);
  min-width: 0;
}

.DashboardContextSection_kpi__head__AILAy {
  display: flex;
  align-items: center;
  gap: 8px;
}

.DashboardContextSection_kpi__icon__UZw6d {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: rgba(15, 52, 96, 0.12);
  color: var(--accent-color, #0f3460);
  flex-shrink: 0;
}

.DashboardContextSection_kpi__label__rBjwa {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.1px;
  color: var(--accent-color, #0f3460);
  opacity: 0.75;
}

.DashboardContextSection_kpi__value__6BKoj {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.4px;
  color: var(--text-1, #1a1a2e);
  line-height: 1.15;
  word-break: break-word;
}

/* ─── Lists Grid ─── */
.DashboardContextSection_lists-grid__3a1EJ {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.DashboardContextSection_list-card__6ppGF {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px 18px 14px;
  border-radius: 12px;
  background: var(--bg-1, #fafafa);
  border: 1px solid rgba(0, 0, 0, 0.05);
  min-width: 0;
}

.DashboardContextSection_list-card__head__nLGRH {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 10px;
}

.DashboardContextSection_list-card__title__1pSwQ {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--accent-color, #0f3460);
}

.DashboardContextSection_list__-QGG8 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.DashboardContextSection_list-row__xMuvt {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  transition: background 0.15s;
}
.DashboardContextSection_list-row__xMuvt:hover {
  background: rgba(15, 52, 96, 0.05);
}

.DashboardContextSection_list-row__meta__\\+ImIC {
  display: grid;
  grid-template-columns: 24px 36px 1fr auto;
  align-items: center;
  gap: 10px;
}

.DashboardContextSection_list-row__rank__vGhGT {
  font-size: 12px;
  font-weight: 700;
  color: var(--grey-text, #94a3b8);
  text-align: center;
}

.DashboardContextSection_list-row__avatar__fhL6f {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  object-fit: cover;
  background: #e2e8f0;
  flex-shrink: 0;
}

.DashboardContextSection_list-row__avatar-fallback__7GhyZ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.DashboardContextSection_list-row__name__viiB9 {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-1, #1a1a2e);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.DashboardContextSection_list-row__value__tapJn {
  font-size: 13px;
  font-weight: 700;
  color: var(--accent-color, #0f3460);
  font-variant-numeric: tabular-nums;
}

.DashboardContextSection_list-row__bar-track__khTO7 {
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: rgba(15, 52, 96, 0.1);
  overflow: hidden;
}

.DashboardContextSection_list-row__bar-fill__b0OLj {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #1e3a5f 0%, #3f5f8f 100%);
  transition: width 0.25s ease;
}

/* ─── States ─── */
.DashboardContextSection_skeleton__JPuKX {
  padding: 8px 0;
}

.DashboardContextSection_error__mkd5v {
  padding: 18px;
  border-radius: 10px;
  background: rgba(255, 77, 79, 0.06);
  border: 1px solid rgba(255, 77, 79, 0.18);
  color: #b91c1c;
  font-size: 13px;
}

.DashboardContextSection_empty__4FWg1 {
  padding: 18px;
  border-radius: 10px;
  background: var(--bg-1, #fafafa);
  border: 1px dashed rgba(0, 0, 0, 0.12);
  color: var(--grey-text, #64748b);
  font-size: 13px;
  text-align: center;
}

/* ─── Responsive ─── */
@media only screen and (max-width: 1100px) {
  .DashboardContextSection_kpis__bV-B8 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .DashboardContextSection_lists-grid__3a1EJ {
    grid-template-columns: 1fr;
  }
}
@media only screen and (max-width: 600px) {
  .DashboardContextSection_section__r0nnL {
    padding: 20px 16px;
    border-radius: 12px;
  }
  .DashboardContextSection_kpis__bV-B8 {
    grid-template-columns: 1fr;
  }
  .DashboardContextSection_kpi__value__6BKoj {
    font-size: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/DashboardContextSection/DashboardContextSection.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,sCAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,wEAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;EACA,aAAA;AACF;;AAEA;EACE,SAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;AACF;;AAEA,sBAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,4FAAA;EACA,wCAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,mCAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mCAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,sBAAA;AACF;;AAEA,uBAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,qCAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;AACF;AACE;EACE,kCAAA;AACJ;;AAGA;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;AAAF;;AAGA;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,iCAAA;EACA,gBAAA;AAAF;;AAGA;EACE,YAAA;EACA,oBAAA;EACA,4DAAA;EACA,4BAAA;AAAF;;AAGA,mBAAA;AACA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,yCAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,sCAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;AAAF;;AAGA,uBAAA;AACA;EACE;IACE,gDAAA;EAAF;EAGA;IACE,0BAAA;EADF;AACF;AAIA;EACE;IACE,kBAAA;IACA,mBAAA;EAFF;EAKA;IACE,0BAAA;EAHF;EAMA;IACE,eAAA;EAJF;AACF","sourcesContent":["/* ─── Dashboard Context Section ─── */\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 28px;\n  background: var(--bg-2, #fff);\n  border-radius: 16px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n}\n\n.head {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: var(--accent-color, #0f3460);\n  opacity: 0.75;\n}\n\n.title {\n  margin: 0;\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-1, #1a1a1a);\n}\n\n.subtitle {\n  margin: 0;\n  font-size: 13px;\n  color: var(--grey-text, #64748b);\n  line-height: 1.5;\n}\n\n/* ─── KPI Cards ─── */\n.kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.kpi {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 18px 20px;\n  border-radius: 12px;\n  background: linear-gradient(140deg, rgba(15, 52, 96, 0.06) 0%, rgba(15, 52, 96, 0.015) 100%);\n  border: 1px solid rgba(15, 52, 96, 0.08);\n  min-width: 0;\n}\n\n.kpi__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.kpi__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  background: rgba(15, 52, 96, 0.12);\n  color: var(--accent-color, #0f3460);\n  flex-shrink: 0;\n}\n\n.kpi__label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.1px;\n  color: var(--accent-color, #0f3460);\n  opacity: 0.75;\n}\n\n.kpi__value {\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.4px;\n  color: var(--text-1, #1a1a2e);\n  line-height: 1.15;\n  word-break: break-word;\n}\n\n/* ─── Lists Grid ─── */\n.lists-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n}\n\n.list-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 18px 18px 14px;\n  border-radius: 12px;\n  background: var(--bg-1, #fafafa);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  min-width: 0;\n}\n\n.list-card__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-start;\n  gap: 10px;\n}\n\n.list-card__title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: var(--accent-color, #0f3460);\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.list-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  transition: background 0.15s;\n\n  &:hover {\n    background: rgba(15, 52, 96, 0.05);\n  }\n}\n\n.list-row__meta {\n  display: grid;\n  grid-template-columns: 24px 36px 1fr auto;\n  align-items: center;\n  gap: 10px;\n}\n\n.list-row__rank {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--grey-text, #94a3b8);\n  text-align: center;\n}\n\n.list-row__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  object-fit: cover;\n  background: #e2e8f0;\n  flex-shrink: 0;\n}\n\n.list-row__avatar-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.list-row__name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-1, #1a1a2e);\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.list-row__value {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--accent-color, #0f3460);\n  font-variant-numeric: tabular-nums;\n}\n\n.list-row__bar-track {\n  width: 100%;\n  height: 8px;\n  border-radius: 999px;\n  background: rgba(15, 52, 96, 0.1);\n  overflow: hidden;\n}\n\n.list-row__bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #1e3a5f 0%, #3f5f8f 100%);\n  transition: width 0.25s ease;\n}\n\n/* ─── States ─── */\n.skeleton {\n  padding: 8px 0;\n}\n\n.error {\n  padding: 18px;\n  border-radius: 10px;\n  background: rgba(255, 77, 79, 0.06);\n  border: 1px solid rgba(255, 77, 79, 0.18);\n  color: #b91c1c;\n  font-size: 13px;\n}\n\n.empty {\n  padding: 18px;\n  border-radius: 10px;\n  background: var(--bg-1, #fafafa);\n  border: 1px dashed rgba(0, 0, 0, 0.12);\n  color: var(--grey-text, #64748b);\n  font-size: 13px;\n  text-align: center;\n}\n\n/* ─── Responsive ─── */\n@media only screen and (max-width: 1100px) {\n  .kpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .lists-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .section {\n    padding: 20px 16px;\n    border-radius: 12px;\n  }\n\n  .kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .kpi__value {\n    font-size: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `DashboardContextSection_section__r0nnL`,
	"head": `DashboardContextSection_head__dxCr5`,
	"eyebrow": `DashboardContextSection_eyebrow__S3L7K`,
	"title": `DashboardContextSection_title__aknQb`,
	"subtitle": `DashboardContextSection_subtitle__iZrXX`,
	"kpis": `DashboardContextSection_kpis__bV-B8`,
	"kpi": `DashboardContextSection_kpi__d3ftl`,
	"kpi__head": `DashboardContextSection_kpi__head__AILAy`,
	"kpi__icon": `DashboardContextSection_kpi__icon__UZw6d`,
	"kpi__label": `DashboardContextSection_kpi__label__rBjwa`,
	"kpi__value": `DashboardContextSection_kpi__value__6BKoj`,
	"lists-grid": `DashboardContextSection_lists-grid__3a1EJ`,
	"list-card": `DashboardContextSection_list-card__6ppGF`,
	"list-card__head": `DashboardContextSection_list-card__head__nLGRH`,
	"list-card__title": `DashboardContextSection_list-card__title__1pSwQ`,
	"list": `DashboardContextSection_list__-QGG8`,
	"list-row": `DashboardContextSection_list-row__xMuvt`,
	"list-row__meta": `DashboardContextSection_list-row__meta__+ImIC`,
	"list-row__rank": `DashboardContextSection_list-row__rank__vGhGT`,
	"list-row__avatar": `DashboardContextSection_list-row__avatar__fhL6f`,
	"list-row__avatar-fallback": `DashboardContextSection_list-row__avatar-fallback__7GhyZ`,
	"list-row__name": `DashboardContextSection_list-row__name__viiB9`,
	"list-row__value": `DashboardContextSection_list-row__value__tapJn`,
	"list-row__bar-track": `DashboardContextSection_list-row__bar-track__khTO7`,
	"list-row__bar-fill": `DashboardContextSection_list-row__bar-fill__b0OLj`,
	"skeleton": `DashboardContextSection_skeleton__JPuKX`,
	"error": `DashboardContextSection_error__mkd5v`,
	"empty": `DashboardContextSection_empty__4FWg1`
};
export default ___CSS_LOADER_EXPORT___;
